import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	width: "100%",
	height: "100%",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M11 7h2v2h-2zm0 4h2v6h-2z" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 3a9 9 0 1 0 9 9 9 9 0 0 0-9-9Zm0 17a8 8 0 1 1 8-8 8 8 0 0 1-8 8Z" })
	]
});
const ForwardRef = forwardRef(SvgInfo);
export default ForwardRef;
